
import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { X } from 'lucide-react';

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [consent, setConsent] = useState({ essential: true, marketing: false });

  useEffect(() => {
    const hasConsented = localStorage.getItem('cookieConsent');
    if (!hasConsented) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setIsVisible(false);
  };

  const handleSave = () => {
    localStorage.setItem('cookieConsent', JSON.stringify(consent));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-white border-t border-emerald-900/10 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] p-4 md:p-6 animate-in slide-in-from-bottom-full duration-500">
      <div className="container mx-auto max-w-6xl">
        {!showSettings ? (
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <div className="flex-1 space-y-2">
              <h3 className="font-serif text-lg font-bold text-emerald-900">Cookie-Einstellungen</h3>
              <p className="text-sm text-stone-600 leading-relaxed">
                Wir nutzen Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten. 
                Einige sind essenziell, andere helfen uns, unsere Inhalte zu verbessern.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto mt-2 md:mt-0">
              <Button 
                variant="outline" 
                onClick={() => setShowSettings(true)}
                className="w-full sm:w-auto border-emerald-900/20 text-emerald-900 hover:bg-emerald-50"
              >
                Einstellungen
              </Button>
              <Button 
                onClick={handleAcceptAll} 
                className="w-full sm:w-auto bg-emerald-900 hover:bg-emerald-800 text-white shadow-md"
              >
                Alle akzeptieren
              </Button>
            </div>
          </div>
        ) : (
          <div className="space-y-6">
            <div className="flex items-center justify-between">
              <h3 className="font-serif text-lg font-bold text-emerald-900">Cookie-Details</h3>
              <Button variant="ghost" size="icon" onClick={() => setShowSettings(false)}>
                <X className="h-5 w-5" />
              </Button>
            </div>
            
            <div className="grid gap-4 bg-stone-50 p-4 rounded-lg border border-stone-100">
              <div className="flex items-center justify-between space-x-2">
                <Label htmlFor="essential" className="flex flex-col space-y-1 cursor-pointer">
                  <span className="font-medium text-stone-900">Essenzielle Cookies</span>
                  <span className="font-normal text-xs text-stone-500">Notwendig für die Website-Funktion (z.B. diese Einstellung).</span>
                </Label>
                <Switch id="essential" checked={true} disabled className="data-[state=checked]:bg-emerald-900" />
              </div>
              <div className="flex items-center justify-between space-x-2">
                <Label htmlFor="marketing" className="flex flex-col space-y-1 cursor-pointer">
                  <span className="font-medium text-stone-900">Analyse & Marketing</span>
                  <span className="font-normal text-xs text-stone-500">Helfen uns, die Website zu verbessern (Google Analytics etc.).</span>
                </Label>
                <Switch 
                  id="marketing" 
                  checked={consent.marketing}
                  onCheckedChange={(checked) => setConsent({ ...consent, marketing: checked })}
                  className="data-[state=checked]:bg-emerald-900"
                />
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-end">
              <Button 
                variant="outline" 
                onClick={() => setShowSettings(false)}
                className="w-full sm:w-auto"
              >
                Zurück
              </Button>
              <Button 
                onClick={handleSave} 
                className="w-full sm:w-auto bg-emerald-900 hover:bg-emerald-800 text-white"
              >
                Auswahl speichern
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
